
const introFormVisible = () => {

    const sections = document.querySelectorAll(".s-intro");

    sections.forEach(section => {
        const buttons = section.querySelectorAll(".s-intro__form-button");
        buttons.forEach(button => {
            button.addEventListener("click", () => {
                const body = document.querySelector("body");
                const form = section.querySelector(".s-intro__form")
                form.classList.add("--js-open");
                body.classList.add("--opened-modal");
            })
        });
    });
}


const introFormHidden = () => {

    const sections = document.querySelectorAll(".s-intro");
    sections.forEach(section => {
        const closes = section.querySelectorAll(".s-intro__form");
        closes.forEach(close => {
            close.addEventListener("click", (e) => {
                const element = e.target as HTMLElement

                if (element.classList.contains("f-offer__close") || element === close) {
                    const body = document.querySelector("body");
                    close.classList.remove("--js-open")
                    body.classList.remove("--opened-modal");
                }
            })
        });
    });
}

introFormVisible();
introFormHidden();
